import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=d82ba156"
import script from "./tinymce.vue?vue&type=script&lang=js"
export * from "./tinymce.vue?vue&type=script&lang=js"
import style0 from "./tinymce.vue?vue&type=style&index=0&id=d82ba156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports